import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IEnable2FA, IOperator } from "./types/_operator";
import { ResponseData } from "./types/_public";
const api = new APIClient();

const path = '/referrals';

const referralApi = {
  rules(params: any): Promise<any> {
    const url = `${path}/rules`
    return api.get(url, params)
  },

  postRule(dataForm: any): Promise<AxiosResponse<ResponseData<IOperator>, any>> {
    const url = `${path}/rules`;
    return api.post(url, dataForm)
  },

  putRule(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IOperator>, any>> {
    const url = `${path}/rules/${id}`;
    return api.put(url, dataForm)
  },

  deleteRule(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IOperator>, any>> {
    const url = `${path}/rules/${id}`;
    return api.delete(url, dataForm)
  },

  triggerEvents(params: any): Promise<any> {
    const url = `${path}/trigger-events`
    return api.get(url, params)
  },

  postTriggerEvent(dataForm: any): Promise<AxiosResponse<ResponseData<IOperator>, any>> {
    const url = `${path}/trigger-events`;
    return api.post(url, dataForm)
  },

  putTriggerEvent(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IOperator>, any>> {
    const url = `${path}/trigger-events/${id}`;
    return api.put(url, dataForm)
  },

  deleteTriggerEvent(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IOperator>, any>> {
    const url = `${path}/trigger-events/${id}`;
    return api.delete(url, dataForm)
  },

  rewards(params: any): Promise<any> {
    const url = `${path}/rewards`
    return api.get(url, params)
  },
  
  putReward(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/rewards/${id}`;
    return api.put(url, dataForm)
  },

  rewardUsers(params: any): Promise<any> {
    const url = `${path}/rewards/users`
    return api.get(url, params)
  },

  withdraws(params: any): Promise<any> {
    const url = `${path}/withdraws`
    return api.get(url, params)
  },

  getWithdraw(id: string | number, params: any = {}): Promise<any> {
    const url = `${path}/withdraws/${id}`;
    return api.get(url, params);
  },

  updateWithdraw(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/withdraws/${id}`;
    return api.put(url, dataForm);
  },

  putWithdraw(id: string | number, dataForm: any): Promise<any> {
    const url = `${path}/withdraw/${id}`;
    return api.put(url, dataForm)
  },

  bankWithdraws(params: any): Promise<any> {
    const url = `/users/banks`
    return api.get(url, params)
  },
}
export default referralApi
